<template>
  <div id="app">
    <router-view />

    <AgentePage v-if="isAgenteVisible" />

    <Analytics />
  </div>
</template>

<script>
import AgentePage from '@/components/agente/AgentePage.vue'
import { Analytics } from '@vercel/analytics/vue'

export default {
  name: 'App',

  components: {
    AgentePage,
    Analytics
  },

  computed: {
    isAgenteVisible() {
      return this.$route.meta.requiresAuth === true
    }
  }
}
</script>